import React from "react";

import CustomAutoCompleteFilter from "../../lib/components/customdatagridfilter/CustomFilter";
import { DateEditor } from "../../lib/components/DateEditor";

import format from "date-fns/format";

const cellWidthMedium = 150;
const cellWidthLarge = 200;

const defaultColumnProperties = {
  resizable: true,
  sortable: true,
};

let currentSpace = true;

const formatDate = (date: Date, time: boolean) => (time ? format(date, "dd MMM yyyy HH:mm") : format(date, "dd MMM yyyy"));

const DateFormatter = (date: string, time = false) => {
  const newDate = date && date.length > 0 ? formatDate(new Date(date.replace("Z", "")), time) : "";
  return <div>{newDate}</div>;
};

export const ColumnsEDISearch = (data, filters, arrangement = undefined, columnsWidth = undefined) => {
  let postValueInfo = "";

  if (data) {
    if (currentSpace) {
      postValueInfo = " ";
    }
    currentSpace = !currentSpace;
  }

  const columns = [
    {
      key: "PTIntakesFO",
      filterable: true,
      name: "PTIntakesFO" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"PTIntakesFO"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "Barcode",
      filterable: true,
      name: "Barcode" + postValueInfo,
      width: cellWidthLarge,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Barcode"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "CustomerID",
      filterable: true,
      name: "Customer ID" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"CustomerID"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "Date",
      filterable: true,
      name: "Date" + postValueInfo,
      width: cellWidthMedium,
      editor: DateEditor,
      formatter: ({ row }) => DateFormatter(row.Date),
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Date"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "IntakeDocRef",
      filterable: true,
      name: "Intake Doc Ref" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"IntakeDocRef"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "Account",
      filterable: true,
      name: "Account" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Account"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "Channel",
      filterable: true,
      name: "Channel" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Channel"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "Season",
      filterable: true,
      name: "Season" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Season"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "InspectionDate",
      filterable: true,
      name: "Inspection Date" + postValueInfo,
      width: cellWidthMedium,
      editor: DateEditor,
      formatter: ({ row }) => DateFormatter(row.InspectionDate),
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"InspectionDate"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "InspectionPoint",
      filterable: true,
      name: "Inspection Point" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"InspectionPoint"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "InspectorName",
      filterable: true,
      name: "Inspector Name" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"InspectorName"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "RejectRep",
      filterable: true,
      name: "RejectRep" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"RejectRep"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "RejectReason",
      filterable: true,
      name: "Reject Reason" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"RejectReason"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "CommodityCode",
      filterable: true,
      name: "Commodity Code" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      // editor: GridDropDownEditor(commoditiesCombo),
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"CommodityCode"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "VarietyCode",
      filterable: true,
      name: "Variety Code" + postValueInfo,
      width: cellWidthMedium,
      // editor: GridDropDownEditor(varietiesCombo),
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"VarietyCode"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "Country",
      filterable: true,
      name: "Country" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Country"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "ActVariety",
      filterable: true,
      name: "ActVariety" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"ActVariety"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "PackCode",
      filterable: true,
      name: "Pack Code" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"PackCode"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "GradeCode",
      filterable: true,
      name: "Grade Code" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"GradeCode"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "ActGrad",
      filterable: true,
      name: "ActGrad" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"ActGrad"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "MarkCode",
      filterable: true,
      name: "Mark Code" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"MarkCode"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "TargetMarket",
      filterable: true,
      name: "Target Market" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"TargetMarket"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "InventoryCode",
      filterable: true,
      name: "Inventory Code" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"InventoryCode"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "PickingRef",
      filterable: true,
      name: "Picking Ref" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"PickingRef"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "CountCode",
      filterable: true,
      name: "Count Code" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"CountCode"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "NoCartons",
      filterable: true,
      name: "No Cartons" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"NoCartons"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "CartonsRejected",
      filterable: true,
      name: "Cartons Rejected" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"CartonsRejected"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "CartonsEvaluated",
      filterable: true,
      name: "Cartons Evaluated" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"CartonsEvaluated"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "PaletteSize",
      filterable: true,
      name: "Palette Size" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"PaletteSize"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "FarmNumber",
      filterable: true,
      name: "PUC" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"FarmNumber"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "IntakeType",
      filterable: true,
      name: "Intake Type" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"IntakeType"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "CoolerID",
      filterable: true,
      name: "Cooler ID" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"CoolerID"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "TimeEntered",
      filterable: true,
      name: "Time Entered" + postValueInfo,
      width: cellWidthMedium,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"TimeEntered"} data={data} section={"editsearchgrid"} />;
      },
    },
    // {
    //   key: "PalTrak",
    //   filterable: true,
    //   name: "PalTrak" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"PalTrak"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    {
      key: "Processing",
      filterable: true,
      name: "Processing" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Processing"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "IntakeUser",
      filterable: true,
      name: "Intake User" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"IntakeUser"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "Inspection",
      filterable: true,
      name: "Inspection" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Inspection"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "Accepted",
      filterable: true,
      name: "Accepted" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Accepted"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "Imported",
      filterable: true,
      name: "Imported" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Imported"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "RegNo",
      filterable: true,
      name: "Ref/Reg No" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"RegNo"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "Carrier",
      filterable: true,
      name: "Carrier" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Carrier"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "Organization",
      filterable: true,
      name: "Organization" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Organization"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "Transport",
      filterable: true,
      name: "Transport" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Transport"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "LoadType",
      filterable: true,
      name: "Load Type" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"LoadType"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "PalletBaseType",
      filterable: true,
      name: "Pallet Base Type" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"PalletBaseType"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "OrderNo",
      filterable: true,
      name: "Order No" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"OrderNo"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "LocationCode",
      filterable: true,
      name: "Location Code" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"LocationCode"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "Destination",
      filterable: true,
      name: "Destination" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Destination"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "ShippingNo",
      filterable: true,
      name: "Shipping No" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"ShippingNo"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "Vessel",
      filterable: true,
      name: "Vessel" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Vessel"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "ContainerNo",
      filterable: true,
      name: "Container No" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"ContainerNo"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "SealNumber",
      filterable: true,
      name: "Seal Number" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"SealNumber"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "ConsecNo",
      filterable: true,
      name: "Consec No" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"ConsecNo"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "Temperature",
      filterable: true,
      name: "Temperature" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Temperature"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "DestinationType",
      filterable: true,
      name: "Destination Type" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"DestinationType"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "FileType",
      filterable: true,
      name: "File Type" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"FileType"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "SequenceNumber",
      filterable: true,
      name: "Sequence Number" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"SequenceNumber"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "WaybillDocument",
      filterable: true,
      name: "Waybill Document" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"WaybillDocument"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "Time",
      filterable: true,
      name: "Time" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Time"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "InspectionTime",
      filterable: true,
      name: "Inspection Time" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"InspectionTime"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "PalletSize",
      filterable: true,
      name: "Pallet Size" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"PalletSize"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "ColdDate",
      filterable: true,
      name: "Cold Date" + postValueInfo,
      width: cellWidthMedium,
      editor: DateEditor,
      formatter: ({ row }) => DateFormatter(row.ColdDate),
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"ColdDate"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "DispatchDocRef",
      filterable: true,
      name: "Dispatch Doc Ref" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"DispatchDocRef"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "Receiver",
      filterable: true,
      name: "Receiver" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Receiver"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "Sender",
      filterable: true,
      name: "Sender" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Sender"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "Remarks",
      filterable: true,
      name: "Remarks" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Remarks"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "OrigIntakeDate",
      filterable: true,
      name: "Orig Intake Date" + postValueInfo,
      width: cellWidthMedium,
      editor: DateEditor,
      formatter: ({ row }) => DateFormatter(row.OrigIntakeDate),
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"OrigIntakeDate"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "OrigIntakeWaybill",
      filterable: true,
      name: "Orig Intake Waybill" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"OrigIntakeWaybill"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "DateEntered",
      filterable: true,
      name: "Date Entered" + postValueInfo,
      width: cellWidthMedium,
      editor: DateEditor,
      formatter: ({ row }) => DateFormatter(row.DateEntered),
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"DateEntered"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "DateDispatched",
      filterable: true,
      name: "Date Dispatched" + postValueInfo,
      width: cellWidthMedium,
      editor: DateEditor,
      formatter: ({ row }) => DateFormatter(row.DateDispatched),
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"DateDispatched"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "PalletID",
      filterable: true,
      name: "Pallet ID" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"PalletID"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "ProducerID",
      filterable: true,
      name: "Producer ID" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      // editor: GridDropDownEditor(producersCombo),
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"ProducerID"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "IntakeID",
      filterable: true,
      name: "Intake ID" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"IntakeID"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "DispatchID",
      filterable: true,
      name: "Dispatch ID" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"DispatchID"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "TimeDispatched",
      filterable: true,
      name: "Time Dispatched" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"TimeDispatched"} data={data} section={"editsearchgrid"} />;
      },
    },
    // {
    //   key: "Selected",
    //   filterable: true,
    //   name: "Selected" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Selected"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "Price",
    //   filterable: true,
    //   name: "Price" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Price"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "Allocated",
    //   filterable: true,
    //   name: "Allocated" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Allocated"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "Allocation",
    //   filterable: true,
    //   name: "Allocation" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Allocation"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    {
      key: "RefNo",
      filterable: true,
      name: "Ref No" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"RefNo"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "IntakeWaybill",
      filterable: true,
      name: "Intake Waybill" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"IntakeWaybill"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "IntakePalletID",
      filterable: true,
      name: "Intake Pallet ID" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"IntakePalletID"} data={data} section={"editsearchgrid"} />;
      },
    },
    // {
    //   key: "Bay",
    //   filterable: true,
    //   name: "Bay" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Bay"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "LastInvoice",
    //   filterable: true,
    //   name: "Last Invoice" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"LastInvoice"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "LastInvoiceDate",
    //   filterable: true,
    //   name: "Last Invoice Date" + postValueInfo,
    //   width: cellWidthMedium,
    //   formatter: ({ row }) => DateFormatter(row.LastInvoiceDate),
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"LastInvoiceDate"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "Invoicing",
    //   filterable: true,
    //   name: "Invoicing" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Invoicing"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "Exported",
    //   filterable: true,
    //   name: "Exported" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Exported"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "Rebuilt",
    //   filterable: true,
    //   name: "Rebuilt" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Rebuilt"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "LastEditDate",
    //   filterable: true,
    //   name: "Last Edit Date" + postValueInfo,
    //   width: cellWidthMedium,
    //   formatter: ({ row }) => DateFormatter(row.LastEditDate),
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"LastEditDate"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "PalletMovement",
    //   filterable: true,
    //   name: "Pallet Movement" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"PalletMovement"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "AllocatedStock",
    //   filterable: true,
    //   name: "Allocated Stock" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"AllocatedStock"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "Rejected",
    //   filterable: true,
    //   name: "Rejected" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Rejected"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "Transfer",
    //   filterable: true,
    //   name: "Transfer" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Transfer"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "MiniPallet",
    //   filterable: true,
    //   name: "Mini Pallet" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"MiniPallet"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "SV",
    //   filterable: true,
    //   name: "SV" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"SV"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "ProductGroup",
    //   filterable: true,
    //   name: "Product Group" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"ProductGroup"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "ProductChar",
    //   filterable: true,
    //   name: "Product Char" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"ProductChar"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "MixedInd",
    //   filterable: true,
    //   name: "Mixed Ind" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"MixedInd"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    {
      key: "Weight",
      filterable: true,
      name: "Weight" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Weight"} data={data} section={"editsearchgrid"} />;
      },
    },
    // {
    //   key: "StockPool",
    //   filterable: true,
    //   name: "Stock Pool" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"StockPool"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    {
      key: "SSCC",
      filterable: true,
      name: "SSCC" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"SSCC"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "PHC",
      filterable: true,
      name: "PHC" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"PHC"} data={data} section={"editsearchgrid"} />;
      },
    },
    // {
    //   key: "SellBy",
    //   filterable: true,
    //   name: "Sell By" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"SellBy"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "StockValue",
    //   filterable: true,
    //   name: "Stock Value" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"StockValue"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    {
      key: "OldBarcode",
      filterable: true,
      name: "Old Barcode" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"OldBarcode"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "TraderID",
      filterable: true,
      name: "Trader ID" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"TraderID"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "ConsigneeID",
      filterable: true,
      name: "Consignee ID" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"ConsigneeID"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "InspectionReport",
      filterable: true,
      name: "Inspection Report" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"InspectionReport"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "UserName",
      filterable: true,
      name: "UserName" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"UserName"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "DispatchCustomerId",
      filterable: true,
      name: "dispatch customer id" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"DispatchCustomerId"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "TempTail",
      filterable: true,
      name: "Temp Tail" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"TempTail"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "Batch",
      filterable: true,
      name: "Batch" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Batch"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "Orchard",
      filterable: true,
      name: "Orchard" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Orchard"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "FileName",
      filterable: true,
      name: "FileName" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"FileName"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "RevisionNo",
      filterable: true,
      name: "Revision No" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"RevisionNo"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "InternalBarcode",
      filterable: true,
      name: "Internal Barcode" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"InternalBarcode"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "TotalPallets",
      filterable: true,
      name: "Total Pallets" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"TotalPallets"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "Week",
      filterable: true,
      name: "Week" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Week"} data={data} section={"editsearchgrid"} />;
      },
    },
    // {
    //   key: "EstimateNo",
    //   filterable: true,
    //   name: "Estimate No" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"EstimateNo"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    {
      key: "PackWeek",
      filterable: true,
      name: "Pack Week" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"PackWeek"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "ArriveWeek",
      filterable: true,
      name: "Arrive Week" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"ArriveWeek"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "SalesWeek",
      filterable: true,
      name: "Sales Week" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"SalesWeek"} data={data} section={"editsearchgrid"} />;
      },
    },
    // {
    //   key: "Units",
    //   filterable: true,
    //   name: "Units" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Units"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    {
      key: "ETD",
      filterable: true,
      name: "ETD" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"ETD"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "PortOfLoading",
      filterable: true,
      name: "Port of Loading" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"PortOfLoading"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "PortOfDischarge",
      filterable: true,
      name: "Port of Discharge" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"PortOfDischarge"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "QCFlag",
      filterable: true,
      name: "QC Flag" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"QCFlag"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "QCUser",
      filterable: true,
      name: "QC User" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"QCUser"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "QCBlocked",
      filterable: true,
      name: "QC Blocked" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"QCBlocked"} data={data} section={"editsearchgrid"} />;
      },
    },
    // {
    //   key: "OrderID",
    //   filterable: true,
    //   name: "Order ID" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"OrderID"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "21",
    //   filterable: true,
    //   name: "21" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"21"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "22",
    //   filterable: true,
    //   name: "22" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"22"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "23",
    //   filterable: true,
    //   name: "23" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"23"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "24",
    //   filterable: true,
    //   name: "24" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"24"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "25",
    //   filterable: true,
    //   name: "25" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"25"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "26",
    //   filterable: true,
    //   name: "26" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"26"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "27",
    //   filterable: true,
    //   name: "27" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"27"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "28",
    //   filterable: true,
    //   name: "28" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"28"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "29",
    //   filterable: true,
    //   name: "29" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"29"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "30",
    //   filterable: true,
    //   name: "30" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"30"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "BatchNumber",
    //   filterable: true,
    //   name: "Batch Number" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"BatchNumber"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "Hatch",
    //   filterable: true,
    //   name: "Hatch" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Hatch"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "Deck",
    //   filterable: true,
    //   name: "Deck" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Deck"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    {
      key: "ProducerName",
      filterable: true,
      name: "Producer Name" + postValueInfo,
      width: cellWidthMedium,
      editable: false,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"ProducerName"} data={data} section={"editsearchgrid"} />;
      },
    },
    // {
    //   key: "PaymentType",
    //   filterable: true,
    //   name: "Payment Type" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"PaymentType"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    {
      key: "ProductionID",
      filterable: true,
      name: "Production ID" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"ProductionID"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "ConsignmentRef",
      filterable: true,
      name: "Consignment Ref" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"ConsignmentRef"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "SubSaleRef",
      filterable: true,
      name: "SubSale Ref" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"SubSaleRef"} data={data} section={"editsearchgrid"} />;
      },
    },
    // {
    //   key: "Currency",
    //   filterable: true,
    //   name: "Currency" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Currency"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "Amount",
    //   filterable: true,
    //   name: "Amount" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Amount"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "ExchangeRate",
    //   filterable: true,
    //   name: "Exchange Rate" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"ExchangeRate"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "RandValue",
    //   filterable: true,
    //   name: "Rand Value" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"RandValue"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "Quantity",
    //   filterable: true,
    //   name: "Quantity" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Quantity"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    {
      key: "ShipAgent",
      filterable: true,
      name: "Ship Agent" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"ShipAgent"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "OrigLocationCode",
      filterable: true,
      name: "Orig Location Code" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"OrigLocationCode"} data={data} section={"editsearchgrid"} />;
      },
    },
    // {
    //   key: "Tax",
    //   filterable: true,
    //   name: "Tax" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Tax"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "ActivityType",
    //   filterable: true,
    //   name: "Activity Type" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"ActivityType"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    {
      key: "ETA",
      filterable: true,
      name: "ETA" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"ETA"} data={data} section={"editsearchgrid"} />;
      },
    },
    // {
    //   key: "InvalidBarcode",
    //   filterable: true,
    //   name: "Invalid Barcode" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"InvalidBarcode"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    {
      key: "FromLocationCode",
      filterable: true,
      name: "From Location Code" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"FromLocationCode"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "NewBarcode",
      filterable: true,
      name: "New Barcode" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"NewBarcode"} data={data} section={"editsearchgrid"} />;
      },
    },
    // {
    //   key: "ActivityDate",
    //   filterable: true,
    //   name: "Activity Date" + postValueInfo,
    //   width: cellWidthMedium,
    //   formatter: ({ row }) => DateFormatter(row.ActivityDate),
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"ActivityDate"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "Verify",
    //   filterable: true,
    //   name: "Verify" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Verify"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "ImportDate",
    //   filterable: true,
    //   name: "Import Date" + postValueInfo,
    //   width: cellWidthMedium,
    //   formatter: ({ row }) => DateFormatter(row.ImportDate),
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"ImportDate"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "InvoiceNumber",
    //   filterable: true,
    //   name: "Invoice Number" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"InvoiceNumber"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "CreditorID",
    //   filterable: true,
    //   name: "Creditor ID" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"CreditorID"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "Description",
    //   filterable: true,
    //   name: "Description" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Description"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "Total",
    //   filterable: true,
    //   name: "Total" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Total"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "SaleID",
    //   filterable: true,
    //   name: "Sale ID" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"SaleID"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "CostItem",
    //   filterable: true,
    //   name: "Cost Item" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"CostItem"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "RemittanceID",
    //   filterable: true,
    //   name: "Remittance ID" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"RemittanceID"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    {
      key: "DocumentType",
      filterable: true,
      name: "Document Type" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"DocumentType"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "ClientRef",
      filterable: true,
      name: "Client Ref" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"ClientRef"} data={data} section={"editsearchgrid"} />;
      },
    },
    // {
    //   key: "CTONo",
    //   filterable: true,
    //   name: "CTO No" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"CTONo"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    {
      key: "ToLocationCode",
      filterable: true,
      name: "To Location Code" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"ToLocationCode"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "TempSerialNo",
      filterable: true,
      name: "Temp Serial No" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"TempSerialNo"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "ShippingLine",
      filterable: true,
      name: "Shipping Line" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"ShippingLine"} data={data} section={"editsearchgrid"} />;
      },
    },
    // {
    //   key: "PalletOnIntake",
    //   filterable: true,
    //   name: "Pallet On Intake" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"PalletOnIntake"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "PalletOnStock",
    //   filterable: true,
    //   name: "Pallet On Stock" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"PalletOnStock"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "FruitTrakInternalPackCode",
    //   filterable: true,
    //   name: "FruitTrak Internal Pack Code" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return (
    //       <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"FruitTrakInternalPackCode"} data={data} section={"editsearchgrid"} />
    //     );
    //   },
    // },
    // {
    //   key: "TranType",
    //   filterable: true,
    //   name: "Tran Type" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"TranType"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "InvoiceID",
    //   filterable: true,
    //   name: "Invoice ID" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"InvoiceID"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "NoOfItems",
    //   filterable: true,
    //   name: "No Of Items" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"NoOfItems"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "FPrice",
    //   filterable: true,
    //   name: "FPrice" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"FPrice"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "FAmount",
    //   filterable: true,
    //   name: "FAmount" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"FAmount"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "CostPerItem",
    //   filterable: true,
    //   name: "Cost Per Item" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"CostPerItem"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "ReportOption",
    //   filterable: true,
    //   name: "Report Option" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"ReportOption"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "PurchasePrice",
    //   filterable: true,
    //   name: "Purchase Price" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"PurchasePrice"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "Depot",
    //   filterable: true,
    //   name: "Depot" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Depot"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "AdvancePrice",
    //   filterable: true,
    //   name: "Advance Price" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"AdvancePrice"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    {
      key: "LoadDate",
      filterable: true,
      name: "Load Date" + postValueInfo,
      width: cellWidthMedium,
      editor: DateEditor,
      formatter: ({ row }) => DateFormatter(row.LoadDate),
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"LoadDate"} data={data} section={"editsearchgrid"} />;
      },
    },
    // {
    //   key: "StartLoadingTime",
    //   filterable: true,
    //   name: "Start Loading Time" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"StartLoadingTime"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    {
      key: "LocalFOB",
      filterable: true,
      name: "Local FOB" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"LocalFOB"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "PreAllocated",
      filterable: true,
      name: "Pre Allocated" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"PreAllocated"} data={data} section={"editsearchgrid"} />;
      },
    },
    // {
    //   key: "InsuranceValue",
    //   filterable: true,
    //   name: "Insurance Value" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"InsuranceValue"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "PurchaseOrderNo",
    //   filterable: true,
    //   name: "Purchase Order No" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"PurchaseOrderNo"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "DepotStockID",
    //   filterable: true,
    //   name: "Depot Stock ID" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"DepotStockID"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "Rebate",
    //   filterable: true,
    //   name: "Rebate" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Rebate"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "ToSequenceNumber",
    //   filterable: true,
    //   name: "To Sequence Number" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"ToSequenceNumber"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    {
      key: "TransactionDate",
      filterable: true,
      name: "Transaction Date" + postValueInfo,
      width: cellWidthMedium,
      editor: DateEditor,
      formatter: ({ row }) => DateFormatter(row.TransactionDate),
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"TransactionDate"} data={data} section={"editsearchgrid"} />;
      },
    },
    // {
    //   key: "InnerPack",
    //   filterable: true,
    //   name: "Inner Pack" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"InnerPack"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "IntakeWeek",
    //   filterable: true,
    //   name: "Intake Week" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"IntakeWeek"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "EqvCartons",
    //   filterable: true,
    //   name: "Eqv Cartons" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"EqvCartons"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    {
      key: "TempType",
      filterable: true,
      name: "Temp Type" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"TempType"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "Qnty",
      filterable: true,
      name: "Qnty" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Qnty"} data={data} section={"editsearchgrid"} />;
      },
    },
    // {
    //   key: "InnerCartons",
    //   filterable: true,
    //   name: "Inner Cartons" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"InnerCartons"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    {
      key: "PalletStatus",
      filterable: true,
      name: "Pallet Status" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"PalletStatus"} data={data} section={"editsearchgrid"} />;
      },
    },
    // {
    //   key: "ContractID",
    //   filterable: true,
    //   name: "Contract ID" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"ContractID"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "TargetPrice",
    //   filterable: true,
    //   name: "Target Price" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"TargetPrice"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    {
      key: "BHTransactionDate",
      filterable: true,
      name: "BH Transaction Date" + postValueInfo,
      width: cellWidthMedium,
      editor: DateEditor,
      formatter: ({ row }) => DateFormatter(row.BHTransactionDate),
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"BHTransactionDate"} data={data} section={"editsearchgrid"} />;
      },
    },
    // {
    //   key: "DepotFiletype",
    //   filterable: true,
    //   name: "Depot File type" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"DepotFiletype"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "GrowingMethod",
    //   filterable: true,
    //   name: "Growing Method" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"GrowingMethod"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "MustGO",
    //   filterable: true,
    //   name: "Must GO" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"MustGO"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "Cycle",
    //   filterable: true,
    //   name: "Cycle" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Cycle"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "AdvancePurchase",
    //   filterable: true,
    //   name: "Advance Purchase" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"AdvancePurchase"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    {
      key: "PackHouseCode",
      filterable: true,
      name: "PackHouse Code" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"PackHouseCode"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "Principal",
      filterable: true,
      name: "Principal" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Principal"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "VarietyGroup",
      filterable: true,
      name: "Variety Group" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"VarietyGroup"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "CommodityGroup",
      filterable: true,
      name: "Commodity Group" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"CommodityGroup"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "VarietyGroupDescription",
      filterable: true,
      name: "Variety Group Description" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"VarietyGroupDescription"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "VarietyDescription",
      filterable: true,
      name: "Variety Description" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"VarietyDescription"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "ShippingWeek",
      filterable: true,
      name: "Shipping Week" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"ShippingWeek"} data={data} section={"editsearchgrid"} />;
      },
    },
    // {
    //   key: "Balance",
    //   filterable: true,
    //   name: "Balance" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Balance"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "RateStructure",
    //   filterable: true,
    //   name: "Rate Structure" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"RateStructure"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    {
      key: "ATA",
      filterable: true,
      name: "ATA" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"ATA"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "ATD",
      filterable: true,
      name: "ATD" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"ATD"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "TargetRegion",
      filterable: true,
      name: "Target Region" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"TargetRegion"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "TargetCountry",
      filterable: true,
      name: "Target Country" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"TargetCountry"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "QCSelected",
      filterable: true,
      name: "QC Selected" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"QCSelected"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "QCUserName",
      filterable: true,
      name: "QC UserName" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"QCUserName"} data={data} section={"editsearchgrid"} />;
      },
    },
    // {
    //   key: "RawCartons",
    //   filterable: true,
    //   name: "Raw Cartons" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"RawCartons"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "RawPallets",
    //   filterable: true,
    //   name: "Raw Pallets" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"RawPallets"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "EqvPallets",
    //   filterable: true,
    //   name: "Eqv Pallets" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"EqvPallets"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "SpecialOrder",
    //   filterable: true,
    //   name: "Special Order" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"SpecialOrder"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    {
      key: "DestinationTypeCN",
      filterable: true,
      name: "Destination Type CN" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"DestinationTypeCN"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "ContainerRef",
      filterable: true,
      name: "ContainerRef" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"ContainerRef"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "NotifyParty",
      filterable: true,
      name: "Notify Party" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"NotifyParty"} data={data} section={"editsearchgrid"} />;
      },
    },
    // {
    //   key: "BestBefore",
    //   filterable: true,
    //   name: "Best Before" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"BestBefore"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "DisplayUntil",
    //   filterable: true,
    //   name: "Display Until" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"DisplayUntil"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    {
      key: "QCCode",
      filterable: true,
      name: "QC Code" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"QCCode"} data={data} section={"editsearchgrid"} />;
      },
    },
    // {
    //   key: "ClaimType",
    //   filterable: true,
    //   name: "Claim Type" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"ClaimType"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "AdditionalDataPath",
    //   filterable: true,
    //   name: "Additional Data Path" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"AdditionalDataPath"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "AdditionalPhotoPath",
    //   filterable: true,
    //   name: "Additional Photo Path" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"AdditionalPhotoPath"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    {
      key: "QCType",
      filterable: true,
      name: "QC Type" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"QCType"} data={data} section={"editsearchgrid"} />;
      },
    },
    // {
    //   key: "PUC",
    //   filterable: true,
    //   name: "PUC" + postValueInfo,
    //   width: cellWidthMedium,
    //   editable: true,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"PUC"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    {
      key: "PackingDate",
      filterable: true,
      name: "Packing Date" + postValueInfo,
      width: cellWidthMedium,
      editor: DateEditor,
      formatter: ({ row }) => DateFormatter(row.PackingDate),
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"PackingDate"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "InspectorCode",
      filterable: true,
      name: "Inspector Code" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"InspectorCode"} data={data} section={"editsearchgrid"} />;
      },
    },
    // {
    //   key: "Labeled",
    //   filterable: true,
    //   name: "Labeled" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Labeled"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "QCPassed",
    //   filterable: true,
    //   name: "QC Passed" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"QCPassed"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "ExpiryCode",
    //   filterable: true,
    //   name: "Expiry Code" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"ExpiryCode"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    {
      key: "OrigPHCLocationCode",
      filterable: true,
      name: "Orig PHC Location Code" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"OrigPHCLocationCode"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "PHCLocationCode",
      filterable: true,
      name: "PHC Location Code" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"PHCLocationCode"} data={data} section={"editsearchgrid"} />;
      },
    },
    // {
    //   key: "EstimateReturn",
    //   filterable: true,
    //   name: "Estimate Return" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"EstimateReturn"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "PurchasePalletID",
    //   filterable: true,
    //   name: "Purchase Pallet ID" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"PurchasePalletID"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "EDIProvider",
    //   filterable: true,
    //   name: "EDI Provider" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"EDIProvider"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "GTINID",
    //   filterable: true,
    //   name: "GTIN ID" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"GTINID"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "Row",
    //   filterable: true,
    //   name: "Row" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Row"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "Position",
    //   filterable: true,
    //   name: "Position" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Position"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "CustomField1",
    //   filterable: true,
    //   name: "Custom Field 1" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"CustomField1"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    {
      key: "OrigFarmNumber",
      filterable: true,
      name: "Orig Farm Number" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"OrigFarmNumber"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "UCRNo",
      filterable: true,
      name: "UCR No" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"UCRNo"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "GTIN",
      filterable: true,
      name: "GTIN" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"GTIN"} data={data} section={"editsearchgrid"} />;
      },
    },
    // {
    //   key: "Percentage",
    //   filterable: true,
    //   name: "Percentage" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Percentage"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "Complexity",
    //   filterable: true,
    //   name: "Complexity" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Complexity"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "IntakeStockValue",
    //   filterable: true,
    //   name: "Intake Stock Value" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"IntakeStockValue"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    {
      key: "GrossWeight",
      filterable: true,
      name: "Gross Weight" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"GrossWeight"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "VoyageNumber",
      filterable: true,
      name: "Voyage Number" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"VoyageNumber"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "OrigInspectionDate",
      filterable: true,
      name: "Orig Inspection Date" + postValueInfo,
      width: cellWidthMedium,
      editor: DateEditor,
      formatter: ({ row }) => DateFormatter(row.OrigInspectionDate),
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"OrigInspectionDate"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "UPN",
      filterable: true,
      name: "UPN" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"UPN"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "ActualVariety",
      filterable: true,
      name: "Actual Variety" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"ActualVariety"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "PalletTreatmentID",
      filterable: true,
      name: "PalletTreatment ID" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"PalletTreatmentID"} data={data} section={"editsearchgrid"} />;
      },
    },
    // {
    //   key: "PoolingPackagingFactor",
    //   filterable: true,
    //   name: "Pooling Packaging Factor" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return (
    //       <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"PoolingPackagingFactor"} data={data} section={"editsearchgrid"} />
    //     );
    //   },
    // },
    // {
    //   key: "ProducerDealType",
    //   filterable: true,
    //   name: "Producer Deal Type" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"ProducerDealType"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    {
      key: "Trailer1",
      filterable: true,
      name: "Trailer1" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Trailer1"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "Trailer2",
      filterable: true,
      name: "Trailer2" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Trailer2"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "VerificationMethod",
      filterable: true,
      name: "Verification Method" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"VerificationMethod"} data={data} section={"editsearchgrid"} />;
      },
    },
    // {
    //   key: "AccreditationNumber",
    //   filterable: true,
    //   name: "Accreditation Number" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"AccreditationNumber"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "AccreditationNumberContainerLevel",
    //   filterable: true,
    //   name: "Accreditation Number Container Level" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"AccreditationNumberContainerLevel"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "ContainerTareWeight",
    //   filterable: true,
    //   name: "Container Tare Weight" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"ContainerTareWeight"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "ContainerGrossWeight",
    //   filterable: true,
    //   name: "Container Gross Weight" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"ContainerGrossWeight"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    {
      key: "WeighingLocation",
      filterable: true,
      name: "Weighing Location" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"WeighingLocation"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "WeighingDateTime",
      filterable: true,
      name: "Weighing Date Time" + postValueInfo,
      width: cellWidthMedium,
      editor: DateEditor,
      formatter: ({ row }) => DateFormatter(row.WeighingDateTime, true),
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"WeighingDateTime"} data={data} section={"editsearchgrid"} />;
      },
    },
    // {
    //   key: "ResponsibleParty",
    //   filterable: true,
    //   name: "Responsible Party" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"ResponsibleParty"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "VitraxUID",
    //   filterable: true,
    //   name: "Vitrax UID" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"VitraxUID"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "VitraxTargetUID",
    //   filterable: true,
    //   name: "Vitrax Target UID" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"VitraxTargetUID"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "FruittrakIntakeID",
    //   filterable: true,
    //   name: "Fruittrak Intake ID" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"FruittrakIntakeID"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "PreIntakeStock",
    //   filterable: true,
    //   name: "PreIntakeStock" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"PreIntakeStock"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    {
      key: "PhytoVerification",
      filterable: true,
      name: "Phyto Verification" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"PhytoVerification"} data={data} section={"editsearchgrid"} />;
      },
    },
    // {
    //   key: "InnerCartonWeight",
    //   filterable: true,
    //   name: "Inner Carton Weight" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"InnerCartonWeight"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "VATCode",
    //   filterable: true,
    //   name: "VAT Code" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"VATCode"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    {
      key: "StartWeek",
      filterable: true,
      name: "Start Week" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"StartWeek"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "EndWeek",
      filterable: true,
      name: "End Week" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"EndWeek"} data={data} section={"editsearchgrid"} />;
      },
    },
    // {
    //   key: "PQINumber",
    //   filterable: true,
    //   name: "PQI Number" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"PQINumber"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "PricingSheetAppliedDate",
    //   filterable: true,
    //   name: "Pricing Sheet Applied Date" + postValueInfo,
    //   width: cellWidthMedium,
    //   formatter: ({ row }) => DateFormatter(row.PricingSheetAppliedDate),
    //   filterRenderer: (e) => {
    //     return (
    //       <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"PricingSheetAppliedDate"} data={data} section={"editsearchgrid"} />
    //     );
    //   },
    // },
    // {
    //   key: "OwnCost",
    //   filterable: true,
    //   name: "Own Cost" + postValueInfo,
    //   width: cellWidthMedium,
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"OwnCost"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "PackDate",
    //   filterable: true,
    //   name: "Pack Date" + postValueInfo,
    //   width: cellWidthMedium,
    //   formatter: ({ row }) => DateFormatter(row.PackDate),
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"PackDate"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    // {
    //   key: "StuffDate",
    //   filterable: true,
    //   name: "Stuff Date" + postValueInfo,
    //   width: cellWidthMedium,
    //   formatter: ({ row }) => DateFormatter(row.StuffDate),
    //   filterRenderer: (e) => {
    //     return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"StuffDate"} data={data} section={"editsearchgrid"} />;
    //   },
    // },
    {
      key: "TempSet",
      filterable: true,
      name: "Temp Set" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"TempSet"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "ContainerAgent",
      filterable: true,
      name: "Container Agent" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"ContainerAgent"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "LotNo",
      filterable: true,
      name: "Lot No" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"LotNo"} data={data} section={"editsearchgrid"} />;
      },
    },
    {
      key: "Waybill",
      filterable: true,
      name: "Waybill" + postValueInfo,
      width: cellWidthMedium,
      editable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"Waybill"} data={data} section={"editsearchgrid"} />;
      },
    },
  ].map((c) => ({ ...c, ...defaultColumnProperties }));

  const columnsArranged = [];

  if (arrangement && arrangement.length > 0) {
    arrangement.map((item) => {
      const indexOfItem = columns.indexOf(columns.find((col) => col.name.trim() === item.toString().trim()));
      if (indexOfItem !== -1) {
        columnsArranged.push(columns[indexOfItem]);
      }
      return undefined;
    });
  } else {
    columns.map((colItem) => {
      columnsArranged.push(colItem);
      return undefined;
    });
  }

  if (columnsWidth && columnsWidth.length > 0) {
    for (let index = 0; index < columnsArranged.length; index++) {
      const element = columnsArranged[index];
      const colItem = columnsWidth.find((colwitem) => colwitem.name.trim() === element.name.trim());
      if (colItem) {
        element.width = colItem.width;
      }
    }
  }

  return columnsArranged;
};

export function getCellActionsDataGrid(column, row) {
  return null;
}
